import * as React from "react";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = (props: ToasterProps) => {
  return (
    <Sonner
      theme="system"
      position="top-right"
      toastOptions={{
        classNames: {
          toast: "group toast group-[.toaster]:rounded-md group-[.toaster]:shadow-lg group-[.toaster]:border",
          success: "bg-green-500 text-white border-green-600",
          error: "bg-red-500 text-white border-red-600",
          info: "bg-blue-500 text-white border-blue-600",
          warning: "bg-yellow-400 text-black border-yellow-500",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
